import { render, staticRenderFns } from "./List-registro-vacinacao-base-nacional.vue?vue&type=template&id=8a096282&scoped=true&"
import script from "./List-registro-vacinacao-base-nacional.vue?vue&type=script&lang=js&"
export * from "./List-registro-vacinacao-base-nacional.vue?vue&type=script&lang=js&"
import style0 from "./List-registro-vacinacao-base-nacional.vue?vue&type=style&index=0&id=8a096282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a096282",
  null
  
)

export default component.exports